import React from 'react';
import { Section } from './ui/Section';
export const FAQSection = () => {
  const faqs = [{
    q: '¿Funciona si soy muy ansioso?',
    a: 'Sí. El sistema está diseñado específicamente para personas con alto nivel de activación mental. No requiere que dejes de ser ansioso. Requiere que aprendas a bajar la cabeza cuando lo necesitás.'
  }, {
    q: '¿Cuánto tiempo tarda en funcionar?',
    a: 'La mayoría de las personas nota diferencia en las primeras 3 noches. Algunas desde la primera. El plan de 21 días está diseñado para que los cambios sean permanentes.'
  }, {
    q: '¿Necesito meditar?',
    a: 'No. Este sistema no tiene nada de meditación ni espiritualidad. Es 100% práctico y directo.'
  }, {
    q: '¿Qué pasa si tengo insomnio muy severo?',
    a: 'Este sistema funciona para insomnio por estrés y rumiación mental. Si tenés un diagnóstico médico específico, consultá con tu médico y usá este sistema como complemento.'
  }, {
    q: '¿Cómo recibo el producto?',
    a: 'Inmediatamente después de la compra recibís el link de descarga en tu mail. Podés acceder desde cualquier dispositivo.'
  }, {
    q: '¿Qué formato tiene?',
    a: 'PDF descargable. Podés leerlo en el celular, la tablet o la computadora. También podés imprimirlo.'
  }, {
    q: '¿Funciona si me despierto de madrugada?',
    a: 'Sí. El Bonus 1 está dedicado específicamente a los despertares de madrugada. Tiene su propio protocolo paso a paso.'
  }, {
    q: '¿Tiene garantía?',
    a: 'Sí. 7 días de garantía total. Si no te sirve, te devolvemos el dinero sin preguntas.'
  }, {
    q: '¿En qué se diferencia de una app de meditación?',
    a: 'Las apps de meditación te distraen. Este sistema ataca la causa real del problema: tu cerebro no recibió la señal de que el día terminó. La distracción no resuelve eso. El Método Apagón Mental sí.'
  }];
  return <Section darker data-id="element-168">
      <div className="max-w-3xl mx-auto" data-id="element-169">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-white" data-id="element-170">
          Preguntas frecuentes
        </h2>

        <div className="space-y-6" data-id="element-171">
          {faqs.map((faq, idx) => <div key={idx} className="bg-night-800 p-6 rounded-2xl border border-night-700" data-id="element-172">
              <h4 className="text-xl font-bold text-white mb-3" data-id="element-173">{faq.q}</h4>
              <p className="text-gray-300 leading-relaxed" data-id="element-174">{faq.a}</p>
            </div>)}
        </div>
      </div>
    </Section>;
};